import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert/alert.component';
import { Alert2Component } from './alert2/alert2.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AlertComponent, Alert2Component],
  exports: [AlertComponent, Alert2Component],
})
export class AlertModule {}
